module.exports = __webpack_public_path__ + "img/12.ab33f97f.jpg";